
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'GalleryFull'
})
export default class GalleryFull extends Vue {}
